var map = {
	"./AW_Logo_Provider ID_Final.png": "611a",
	"./AmLogoNewWhiteStrokeAug13Wy 1.png": "57b7",
	"./AppointmentInfo.svg": "a9fc",
	"./D.svg": "9414",
	"./DHI.svg": "c577",
	"./DHI_Tele.png": "9769",
	"./DHealth.svg": "988b",
	"./D_Health.png": "08bc",
	"./Frame 427320051.png": "f520",
	"./Frame 427322911.png": "993e",
	"./Frame 427322912.png": "cb79",
	"./Frame 427323560.png": "6e67",
	"./Frame 6.png": "48e4",
	"./Group 11.svg": "d0924",
	"./Group 427323441.png": "3194",
	"./Group 427323550.png": "90b1",
	"./Group.png": "3f5f",
	"./MedicalHistory.svg": "08f3",
	"./Tele.svg": "3c67",
	"./TeleHealth.svg": "a66b",
	"./Tele_Consult.png": "49f6",
	"./add photo.png": "06dd",
	"./appointment-success.png": "35e0",
	"./ava.png": "b581",
	"./bglogin.png": "7e9e",
	"./cash.png": "c1b2",
	"./conference.png": "9ee5",
	"./debit_card.png": "7a2d",
	"./female_woman_person_people_avatar_icon_159366.png": "ded0",
	"./gallery.png": "f736",
	"./homevisit_01.svg": "8875",
	"./homevisit_02.svg": "74eb",
	"./homevisit_03.svg": "ef19",
	"./homevisit_04.svg": "e5cc",
	"./hospital.png": "e173",
	"./lineqrcode.png": "716f",
	"./logo NCDs.png": "be41",
	"./logo clinical 5.png": "36f5",
	"./logo สมบูรณ์ copy 2.png": "c578",
	"./logo-doctor-near-me-small.png": "a7be",
	"./logo_NRCT 1.png": "be53",
	"./logo_ddc.svg": "0d52",
	"./logo_tele.svg": "d581",
	"./logoline.webp": "3066",
	"./male_boy_person_people_avatar_icon_159358.png": "75ff",
	"./map.png": "2d7d",
	"./money.png": "9629",
	"./notification.png": "7db3",
	"./paymentOnline.png": "229b",
	"./person.png": "3b55",
	"./pharmacy.png": "1ec2",
	"./qr_code.png": "4fb5",
	"./teeth.png": "dfc8",
	"./upload.png": "fe63",
	"./voucher.png": "14d5",
	"./wallpaper.png": "aa32",
	"./wallpaper2.png": "bd93"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e107";